// @flow

// NOTE(jackhsu): When shallow rendering <ScrollFetch /> in snapshot test, the test
// throws an exception  "Cannot convert undefined or null to object", as it is not
// able to handle the defaultProp `container` in <ScrollFetch />. As a workaround, we
// create this proxy component <ScrollFetch /> to avoid the error.

import * as React from 'react';
import { ScrollFetch } from 'gestalt';

type Props = {|
  fetchMore: () => void,
  isAtEnd: boolean,
  isFetching: boolean,
|};

export default function TestableScrollFetch(props: Props) {
  return <ScrollFetch {...props} />;
}
